module.exports = "<div seedelement>\n  <div class=\"label\">\n    <span class=\"text\"><slot></slot></span>\n    <slot name=\"controls\"></slot>\n  </div>\n  <slot name=\"input\"></slot>\n</div>\n"


//////////////////
// WEBPACK FOOTER
// ./packages/lui-label/theme/lui-label.html
// module id = 230
// module chunks = 0 1 32